@if (invoices && invoices.length > 0) {
  <div class="bg-surface shadow overflow-hidden sm:rounded-md">
    <ul>
      @for (invoice of invoices; track invoice.id; let isFirst = $first) {
        <li
          app-invoice-list-entry
          [invoice]="invoice"
          [ngClass]="{ 'border-t border-edge': !isFirst }"
          (editInvoice)="editInvoice.emit(invoice)"
        ></li>
      }
    </ul>
  </div>
} @else {
  <app-empty-state
    iconName="heroBanknotes"
    heading="Keine Rechnungen"
    class="flex justify-center mt-[100px]"
  ></app-empty-state>
}
